import React from 'react';
import './Search.css'
import Filter from '../../Assets/Icons/Filter.svg';

const Search = () => {
    return ( 
        <>
        <input className='SearchBar' type="text" placeholder='Search...' />

        <button className='FilterBtn'>
            <p>Filter</p>
            <img src={Filter} alt="" />
        </button>
        </>
     );
}
 
export default Search;